import React, { ReactElement } from 'react';
import { Tag } from 'idsk-react-components';

interface Props {
  isOdoslana: boolean;
}

const PripomienkaOdoslanaTag = ({ isOdoslana }: Props): ReactElement => {
  if (isOdoslana) {
    return (
      <Tag className="odoslana-tag" size="small" type="success">Odoslaná</Tag>
    );
  }
  return (
    <Tag className="odoslana-tag" size="small" type="danger">Neodoslaná</Tag>
  );
};

export default PripomienkaOdoslanaTag;
